<template>
  <section class="home" style="height: 100vh; display: flex; align-items: center; justify-content: center; flex-direction: column;">
    <div class="mb-4 text-center">
      <svg xmlns="http://www.w3.org/2000/svg" class="bi bi-check-circle text-success" width="75" height="75"
        fill="currentColor" viewBox="0 0 16 16">
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
        <path
          d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
      </svg>
    </div>
    <div class="jumbotron text-center">
      <h1 class="display-3">Thank You!</h1>
      <p class="lead">
        We've sent you an <b>email</b> for payment confirmation and other instructions.
      </p>
      <p>
        Having trouble? <a href="#" style="text-decoration: none; " >Contact us</a>
      </p>
      <p class="lead">
        <a class="btn btn-primary btn-sm" href="https://test-bnb.nsjbi.com.ph/" role="button">Go back to homepage</a>
      </p>
    </div>
  </section>
<!-- 
  <h1>
        Thanks!
      </h1>
      {{ txnid }}
      <br />
      {{ refno }}
      <br />
      {{ status == "S" ? "Success" : "" }}
      <br />
      {{ message }}
      <br />
      {{ digest }} -->
</template>

<script>
export default {
  name: "ThankYou",
  data: () => ({
    txnid: "",
    refno: "",
    status: "",
    message: "",
    digest: "",
  }),
  mounted() {
    this.txnid = this.$route.query.txnid != null ? this.$route.query.txnid : "";
    this.refno = this.$route.query.refno != null ? this.$route.query.refno : "";
    this.status = this.$route.query.status != null ? this.$route.query.status : "";
    // this.message = this.$route.query.message != null ? this.$route.query.message : "";
    // this.digest = this.$route.query.digest != null ? this.$route.query.digest : "";
    this.getUnitDetails()
  },
  created() {
    this.getUnitDetails()
  },
  methods: {
    async getUnitDetails() {
      const formData = new FormData();
      formData.append("DragonPayTransactionNo", this.txnid);
      formData.append("DragonPayRefNo", this.refno);
      formData.append("DragonpayStatus", this.status);
      // formData.append("DateCheckout", this.message);
      // formData.append("AdultNumber", this.digest);

      try {
        const res = await axios.post(
          "https://testbnb-api.nsjbi.com.ph/api/payment",
          formData
        );
        if (res.data != null) {
          console.log("salamat")
          console.log(formData)
          //window.open(res.data.data, "_blank");
        }
      } finally {

      }

    },
  }
};
</script>
